import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as selectorsCartoes from 'store/cartao/reducer';
import * as actionsCartoes from 'store/cartao/actions';
import DefaultSelectV2 from '../DefaultSelectV2';
import SearchSelectV2 from '../SearchSelectV2';

const CartaoSelectV2 = ({
  cartoesOptions,
  onSelect,
  value,
  error,
  findCartoesOptions,
  disabled,
  isRequired,
  multiSelect,
  label,
}) => {
  useEffect(() => {
    findCartoesOptions();
  }, [findCartoesOptions]);

  const searchOptions = useMemo(
    () =>
      (cartoesOptions || []).map((c) => ({
        value: c.id,
        label: c.codigo,
      })),
    [cartoesOptions],
  );

  if (multiSelect) {
    return (
      <SearchSelectV2
        label={label}
        multiSelect
        disabled={disabled}
        options={searchOptions}
        error={error}
        isRequired={isRequired}
        onSelect={onSelect}
        value={value}
      />
    );
  }

  const handleChange = (event) => onSelect(event.target.value);

  return (
    <DefaultSelectV2
      error={error}
      disabled={disabled}
      isRequired={isRequired}
      label={label}
      name="cartao"
      optionLabel="codigo"
      onSelect={handleChange}
      options={cartoesOptions || []}
      showEmpty
      value={value}
    />
  );
};

CartaoSelectV2.propTypes = {
  error: PropTypes.bool,
  /** Single: string ID; multi: array of IDs */
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ]),
  cartoesOptions: PropTypes.array,
  isRequired: PropTypes.any,
  /** Single: `(id:string) => void`; multi: `(ids:string[] | null) => void` */
  onSelect: PropTypes.func.isRequired,
  findCartoesOptions: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  multiSelect: PropTypes.bool,
  label: PropTypes.string,
};

CartaoSelectV2.defaultProps = {
  error: false,
  cartoesOptions: [],
  isRequired: false,
  disabled: false,
  multiSelect: false,
  label: 'Cartão Corporativo',
};

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsCartoes }, dispatch);
const mapStateToProps = (state) => ({ cartoesOptions: selectorsCartoes.getCartoesOptions(state) });
export default connect(mapStateToProps, mapDispatchToProps)(CartaoSelectV2);
